import styled from 'styled-components';

const HelpContainerStyled = styled.div`
  height: fit-content;
  background: #fff;
  border-radius: 8px;
  min-width: 100%;
  padding-bottom: 8px;
  margin-bottom: 24px;
`;

const HelpHeaderStyled = styled.div`
  padding: 16px;
  border-bottom: 1px solid #e2e6ea;
  & > h1 {
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    color: #0e141d;
  }

  & > h2 {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #494c66;
  }
`;

const HelpContentStyled = styled.div`
  align-items: end;
  padding: 24px 16px 8px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  row-gap: 16px;
  column-gap: 8px;
  max-width: 400px;
  margin: auto;

  & > div:last-of-type {
    span {
      max-width: 75px;
    }
  }
`;

export { HelpContainerStyled, HelpHeaderStyled, HelpContentStyled };
